const ROLE_LABELS = {
  Founder: 'Founder',
  Admin: 'Admin',
  SuperAdmin: 'Super Admin',
  HumanResource: 'Human Resource',
  Accounts: 'Accounts',
  Department_Head: 'Department Head',
  Employee: 'Employee',
  Social_Media_Manager: 'Social Media Manager',
  Task_manager: 'Task Manager',
  Ex_employee: 'Ex-Employee',
  Unverified: 'Unverified',
};

function titleCase(value) {
  return value.replace(/\b[a-z]/g, (char) => char.toUpperCase());
}

export function formatRoleLabel(roleName) {
  if (roleName == null) return '';
  const raw = String(roleName).trim();
  if (!raw) return '';
  if (ROLE_LABELS[raw]) return ROLE_LABELS[raw];

  const spaced = raw
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();

  return spaced ? titleCase(spaced) : raw;
}

export function roleOption(roleName) {
  return { label: formatRoleLabel(roleName), value: roleName };
}
